import React from 'react'

import { Form, Checkbox, Input, Select } from 'semantic-ui-react'

export default ({
  name,
  description,
  enabled,
  categoryId,
  categories,
  isEdited,
  saveBaseProduct,
  handleChange
}) => {
  let categoryOptions = categories.map(({ id, name }) => {
    return { key: id, text: name, value: id }
  })
  categoryOptions = [
    { key: 'no', text: 'No Category', value: null },
    ...categoryOptions
  ]
  return (
    <Form onSubmit={saveBaseProduct}>
      <Form.Group>
        <Form.Button
          disabled={!isEdited}
          positive
          basic
          onClick={saveBaseProduct}
        >
          Save Base Product
        </Form.Button>
        <Form.Field
          control={Checkbox}
          label={enabled ? 'Enabled' : 'Disabled'}
          toggle
          checked={enabled}
          name="enabled"
          onChange={handleChange}
        />
      </Form.Group>
      <Form.Group widths="equal">
        <Form.Field
          control={Input}
          label="Name"
          placeholder="Name"
          value={name}
          name="name"
          onChange={handleChange}
        />
        <Form.Field
          control={Input}
          label="Description"
          placeholder="Description"
          value={description}
          name="description"
          onChange={handleChange}
        />
        <Form.Field
          control={Select}
          label="Category"
          placeholder="Category"
          value={categoryId}
          options={categoryOptions}
          name="categoryId"
          onChange={handleChange}
        />
      </Form.Group>
    </Form>
  )
}



// WEBPACK FOOTER //
// ./src/components/EditBaseProductForm.jsx